import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { Typography, Box, Tabs, Tab, Paper, Radio } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { hideModal } from 'state/actions';
import { MODAL, COLOR, ADD_NEW_FAVORITE_LISTING_STEP, ENG } from 'config/constants';
import { useAuth, useListing, useLanguage } from 'hooks';
import { isMobile } from 'utils/screen';
import { HvModal, HvButton, HvStepperDots } from 'components';
import { images } from 'assets/images';

const useStyles = makeStyles({
  content: {
    padding: 20,
    maxWidth: 600,
    margin: 'auto',
    '@media (max-width: 800px)': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  option: {
    padding: '30px 20px',
    marginBottom: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0px 4px 15px 4px rgba(0, 0, 0, 0.1)',
    '@media (max-width: 800px)': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  cancelButton: {
    backgroundColor: 'white',
    marginRight: 20,
    color: '#00bdf2',
    border: '1px solid #00bdf2',
  },
  image: {
    height: 'auto',
    width: '25%',
    marginRight: 30,
    '@media (max-width: 800px)': {
      width: '100%',
      marginRight: 0,
    },
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '@media (max-width: 800px)': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
    },
  },
});
interface Props {
  setActiveStep: (_: number) => void;
  activeStep: number;
}
function AddNewFavoriteListingOptions({ setActiveStep, activeStep }: Props) {
  const intl = useIntl();
  const styles = useStyles();
  const language = useLanguage();
  const dispatch = useDispatch();
  const { user } = useAuth();
  const [current, setCurrent] = useState(0);

  const [useDemoListing, setUseDemoListing] = useState(true);
  const fmtAddOwnListing = intl.formatMessage({ id: 'portal.addOwnListing' });
  const fmtAddHausvaletListings = intl.formatMessage({ id: 'portal.addHausvaletListings' });

  useEffect(() => {});
  const onClose = () => {
    dispatch(hideModal(MODAL.ADD_NEW_FAVORITE_LISTING));
  };
  const onBack = () => {
    dispatch(hideModal(MODAL.ADD_NEW_FAVORITE_LISTING));
  };
  const onNext = () => {
    if (useDemoListing) {
      setActiveStep(ADD_NEW_FAVORITE_LISTING_STEP.DEMO_LISTINGS);
    } else {
      setActiveStep(ADD_NEW_FAVORITE_LISTING_STEP.SEARCH_LISTING);
    }
  };
  const buttons = (
    <Box>
      <HvButton className={styles.cancelButton} onClick={onBack}>
        {intl.formatMessage({ id: 'deliver.photos.cancel' })}
      </HvButton>
      <HvButton onClick={onNext}>{intl.formatMessage({ id: 'deliver.photos.next' })}</HvButton>
    </Box>
  );
  return (
    <HvModal
      title={intl.formatMessage({ id: 'portal.addYourListings' })}
      onClose={onClose}
      largerWidth={!isMobile()}
      buttons={buttons}
    >
      <Box className={styles.content}>
        <Paper className={styles.option}>
          <Box className={styles.row}>
            <img className={styles.image} src={images.empty_listing} alt='empty listing' />
            <Typography>{fmtAddHausvaletListings}</Typography>
          </Box>
          <Box>
            <Radio
              checked={useDemoListing}
              color='secondary'
              onChange={() => {
                setUseDemoListing(true);
              }}
              value
              name='radio-button-demo'
              inputProps={{ 'aria-label': 'A' }}
            />
          </Box>
        </Paper>
        <Paper className={styles.option}>
          <Box className={styles.row}>
            <img className={styles.image} src={images.empty_listing} alt='empty listing' />
            <Typography>{fmtAddOwnListing}</Typography>
          </Box>
          <Box>
            <Radio
              checked={!useDemoListing}
              color='secondary'
              onChange={() => {
                setUseDemoListing(false);
              }}
              value
              name='radio-button-demo'
              inputProps={{ 'aria-label': 'A' }}
            />
          </Box>
        </Paper>
        <HvStepperDots activeDot={activeStep} numberOfDots={3} />
      </Box>
    </HvModal>
  );
}
export default AddNewFavoriteListingOptions;
